// @flow
import React from "react";
import bem from "@justpark/helpers/src/bem/bem";

import "./radio.scss";

const baseClass = "c-radio";

type Props = {
  name: string,
  onChange: () => {},
  checked: boolean,
  value: ?string | ?number,
  id?: string,
  cypress?: string | null,
  className?: string,
  hasBorderColor?: boolean
};

const Radio = ({
  name,
  onChange,
  checked,
  value,
  id = "",
  cypress = null,
  className = "",
  hasBorderColor = false
}: Props) => (
  <span
    className={`${bem(baseClass, null, {
      checked,
      border: hasBorderColor
    })} ${className}`}
  >
    <input
      type="radio"
      name={name}
      onChange={onChange}
      checked={checked}
      value={value}
      id={id}
      data-cy={cypress}
    />
  </span>
);

export default Radio;
